<template>
  <div class="container-fluid">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir projecte" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="nuevo-seguiment" v-model="nuevos.proyecto.seguiment" :disabled="loading.creacion" />
                <label class="custom-control-label" for="nuevo-seguiment">Seguiment activitat</label>
              </div>
              <div class="form-group">
                <label for="nuevo-titol">Títol</label>
                <input ref="autofocusCreacion" type="text" class="form-control" id="nuevo-titol" v-model="nuevos.proyecto.titol" :disabled="loading.creacion" maxlength="255" required />
              </div>
              <div class="form-group">
                <label for="nuevo-cliente">Client</label>
                <select class="form-control" id="nuevo-cliente" v-model="nuevos.proyecto.id_client" :disabled="loading.creacion" required>
                  <option v-for="(cliente, index) in clientes" :key="index" :value="cliente.id">{{ cliente.titol }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-tipus">Tipus</label>
                <select class="form-control" id="nuevo-tipus" v-model="nuevos.proyecto.tipus" :disabled="loading.creacion" required>
                  <option v-for="(uno, index) in tipus" :key="index">{{ uno }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-linia_negoci">Línia de negoci</label>
                <select class="form-control" id="nuevo-linia_negoci" v-model="nuevos.proyecto.linia_negoci" :disabled="loading.creacion">
                  <option value=""></option>
                  <option v-for="(l, i) in lineas" :key="i" :value="l">{{ l }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-responsable">Responsable</label>
                <select class="form-control" id="nuevo-responsable" v-model="nuevos.proyecto.responsable" :disabled="loading.creacion">
                  <option value=""></option>
                  <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-data_limit">Data límit</label>
                <div class="input-group">
                  <input type="date" class="form-control" id="nuevo-data_limit" v-model="nuevos.proyecto.data_limit" :disabled="loading.creacion" :min="minFecha" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-codi_pressupost">Codi pressupost</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="nuevo-codi_pressupost" v-model="nuevos.proyecto.codi_pressupost" :disabled="loading.creacion" maxlength="255" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-directori">Ruta directori</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="nuevo-directori" v-model="nuevos.proyecto.directori" :disabled="loading.creacion" maxlength="255" />
                </div>
              </div>
              <div v-for="(item, index) in perfiles" :key="index" class="form-group">
                <label :for="`nuevo-previsio_hores_${index}`">Previsió hores {{ item }}</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" :id="`nuevo-previsio_hores_${index}`" v-model="nuevos.proyecto.horas[item]" :disabled="loading.creacion" min="0" max="65535" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-previsio_costos">Previsió costos</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-previsio_costos" v-model="nuevos.proyecto.previsio_costos" :disabled="loading.creacion" min="0" max="999999.99" />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-marge_comercial">Marge comercial</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-marge_comercial" v-model="nuevos.proyecto.marge_comercial" :disabled="loading.creacion" min="0" max="100" />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-marge_comercial">Nom contacte</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="nuevo-contacte_nom" v-model="nuevos.proyecto.contacte_nom" :disabled="loading.creacion" maxlength="255" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-marge_comercial">Càrrec contacte</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="nuevo-contacte_carrec" v-model="nuevos.proyecto.contacte_carrec" :disabled="loading.creacion" maxlength="255" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-marge_comercial">E-mail contacte</label>
                <div class="input-group">
                  <input type="email" class="form-control" id="nuevo-contacte_email" v-model="nuevos.proyecto.contacte_email" :disabled="loading.creacion" maxlength="320" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-marge_comercial">Telèfon contacte</label>
                <div class="input-group w-50">
                  <input type="tel" class="form-control" id="nuevo-contacte_telefon" v-model="nuevos.proyecto.contacte_telefon" :disabled="loading.creacion" maxlength="15" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-tags">Etiquetes</label>
                <etiquetes v-model="nuevos.proyecto.tags" input-id="nuevo-tags" :disabled="loading.creacion" />
              </div>
              <div class="form-group">
                <label for="nuevo-notes">Notes</label>
                <textarea class="form-control" id="nuevo-notes" v-model="nuevos.proyecto.notes" :disabled="loading.creacion" maxlength="5000" rows="4"></textarea>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion"><i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar</button>
          </template>
        </modal>
      </li>
      <li class="list-inline-item">
        <modal ref="modalTransferencia" titulo="Transferir registres" icono="fa-solid fa-share-from-square" :clases="['modal-lg']" :loading="loading.transferencia" @abrir="abrirModal('autofocusTransferencia')" @cerrar="cerrarTransferencia">
          <template v-slot:body>
            <form id="form-transferencia" autocomplete="off" @submit.prevent="transferir">
              <div class="form-group">
                <label for="transferencia-cliente">Client</label>
                <select ref="autofocusTransferencia" class="form-control" id="transferencia-cliente" v-model="nuevos.transferencia.id_client" :disabled="loading.transferencia" required>
                  <option v-for="(cliente, index) in clientes_todos" :key="index" :value="cliente.id">{{ cliente.titol }}</option>
                </select>
              </div>
              <div class="alert alert-info" role="alert"><i class="fa-solid fa-triangle-exclamation"></i> S'eliminarà el projecte <b>Origen</b>, i es mantindrà el projecte <b>Destí</b> amb les seves dades: només seran transferides dedicacions i despeses.</div>
              <div class="row">
                <div class="col d-flex align-items-center justify-content-around">
                  <label for="transferencia-proyecto-origen">Origen</label>
                  <i class="fa-solid fa-arrow-right-arrow-left" role="button" tabindex="0" @click="intercambiar"></i>
                  <label for="transferencia-proyecto-destino">Destí</label>
                </div>
              </div>
              <div class="row" :class="{ invisible: !transferenciaProyectos.length }" style="min-height: 510px">
                <div class="col">
                  <div class="form-group">
                    <select class="form-control" id="transferencia-proyecto-origen" v-model="nuevos.transferencia.origen" :disabled="loading.transferencia" required>
                      <option v-for="(proyecto, index) in transferenciaProyectos" :key="index" :value="proyecto.id" :disabled="nuevos.transferencia.destino == proyecto.id">{{ proyecto.titol }}</option>
                    </select>
                  </div>
                  <desglose-proyecto v-if="transferenciaOrigen" :proyecto="transferenciaOrigen" />
                </div>
                <div class="col">
                  <div class="form-group">
                    <select class="form-control" id="transferencia-proyecto-destino" v-model="nuevos.transferencia.destino" :disabled="loading.transferencia" required>
                      <option v-for="(proyecto, index) in transferenciaProyectos" :key="index" :value="proyecto.id" :disabled="nuevos.transferencia.origen == proyecto.id">{{ proyecto.titol }}</option>
                    </select>
                  </div>
                  <desglose-proyecto v-if="transferenciaDestino" :proyecto="transferenciaDestino" />
                </div>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-transferencia" :disabled="loading.transferencia"><i-submit icono="fa-share-from-square" :loading="loading.transferencia" />Confirmar</button>
          </template>
        </modal>
      </li>
      <li class="list-inline-item">
        <button class="btn btn-primary" :disabled="loading.exportarTancats" @click="exportarTancatsDarrerTrimestre">
          <i v-if="!loading.exportarTancats" class="fa-solid fa-file-export mr-1"></i>
          <span v-else class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          Exportar darrer trimestre
        </button>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap projecte</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar projecte" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar projecte" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar projecte" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`actiu${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).es_actiu" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`actiu${props.row.id}`">Actiu</label>
                </div>
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`seguiment${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).seguiment" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`seguiment${props.row.id}`">Seguiment activitat</label>
                </div>
                <div class="form-group">
                  <label :for="`titol${props.row.id}`">Títol</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="text" class="form-control" :id="`titol${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).titol" :disabled="loading.edicion" maxlength="255" required />
                </div>
                <div class="form-group">
                  <label :for="`cliente${props.row.id}`">Client</label>
                  <select class="form-control" :id="`cliente${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).id_client" :disabled="loading.edicion" required>
                    <option v-for="(cliente, index) in clientes_todos" :key="index" :value="cliente.id">{{ cliente.titol }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`tipus${props.row.id}`">Tipus</label>
                  <select class="form-control" :id="`tipus${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).tipus" :disabled="loading.edicion" required>
                    <option v-for="(uno, index) in tipus" :key="index">{{ uno }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`linia_negoci${props.row.id}`">Línia de negoci</label>
                  <select class="form-control" :id="`linia_negoci${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).linia_negoci" :disabled="loading.edicion">
                    <option value=""></option>
                    <option v-for="(l, i) in lineas" :key="i" :value="l">{{ l }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`trabajador${props.row.id}`">Responsable</label>
                  <select class="form-control" :id="`trabajador${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).responsable" :disabled="loading.edicion">
                    <option value=""></option>
                    <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`data_limit${props.row.id}`">Data límit</label>
                  <input type="date" class="form-control" :id="`data_limit${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).data_limit" :disabled="loading.edicion" />
                </div>
                <div class="form-group">
                  <label :for="`codi_pressupost${props.row.id}`">Codi pressupost</label>
                  <input type="text" class="form-control" :id="`codi_pressupost${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).codi_pressupost" :disabled="loading.edicion" maxlength="255" />
                </div>
                <div class="form-group">
                  <label :for="`directori${props.row.id}`">Ruta directori</label>
                  <input type="text" class="form-control" :id="`directori${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).directori" :disabled="loading.edicion" maxlength="255" />
                </div>
                <div v-for="(item, index) in perfiles" :key="index" class="form-group">
                  <label :for="`previsio_hores_${index}_${props.row.id}`">Previsió hores {{ item }}</label>
                  <div class="input-group w-50">
                    <input type="number" class="form-control" :id="`previsio_hores_${index}_${props.row.id}`" v-model="getRowHoras(props.row.id, rowsBuffer)[item]" :disabled="loading.edicion" min="0" max="65535" />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`previsio_costos${props.row.id}`">Previsió costos</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`previsio_costos${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).previsio_costos" :disabled="loading.edicion" min="0" max="999999.99" />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`marge_comercial${props.row.id}`">Marge comercial</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`marge_comercial${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).marge_comercial" :disabled="loading.edicion" min="0" max="100" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="nuevo-marge_comercial">Nom contacte</label>
                  <div class="input-group">
                    <input type="text" class="form-control" :id="`contacte_nom${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).contacte_nom" :disabled="loading.creacion" maxlength="255" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="nuevo-marge_comercial">Càrrec contacte</label>
                  <div class="input-group">
                    <input type="text" class="form-control" :id="`contacte_carrec${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).contacte_carrec" :disabled="loading.creacion" maxlength="255" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="nuevo-marge_comercial">E-mail contacte</label>
                  <div class="input-group">
                    <input type="email" class="form-control" :id="`contacte_email${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).contacte_email" :disabled="loading.creacion" maxlength="320" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="nuevo-marge_comercial">Telèfon contacte</label>
                  <div class="input-group w-50">
                    <input type="tel" class="form-control" :id="`contacte_telefon${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).contacte_telefon" :disabled="loading.creacion" maxlength="15" />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`tags${props.row.id}`">Etiquetes</label>
                  <etiquetes v-model="getRowId(props.row.id, rowsBuffer).tags" :input-id="`tags${props.row.id}`" :disabled="loading.edicion" />
                </div>
                <div class="form-group">
                  <label :for="`notes${props.row.id}`">Notes</label>
                  <textarea class="form-control" :id="`notes${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).notes" :disabled="loading.edicion" maxlength="5000" rows="4"></textarea>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar projecte" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar <b>{{ props.row.titol }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="es_actiu" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
      <template slot="seguiment" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
      <template slot="codi_pressupost" slot-scope="props">
        <button v-if="props.row.directori" class="btn btn-link">
          <presupuesto :codigo="props.cell_value" :directorio="props.row.directori" />
        </button>
      </template>
      <template slot="titol" slot-scope="props">
        <router-link :to="{ path: '/recursos-projecte', query: { id: props.row.id, filtre: 'tot' } }" target="_blank">{{ props.cell_value }}</router-link>
      </template>
      <template slot="data_limit_cell" slot-scope="props">
        {{ props.row.data_limit_format }}
      </template>
      <template slot="linia_negoci" slot-scope="props">
        <span class="badge badge-primary">{{ props.cell_value }}</span>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
import DesgloseProyecto from "../components/DesgloseProyecto.vue";
import Etiquetes from "../components/Etiquetes.vue";
import Presupuesto from "../components/Presupuesto.vue";

export default {
  components: { DesgloseProyecto, Etiquetes, Presupuesto },
  name: "Projectes",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "mostrarBolcat", "actionsExportar", "exportarDatos", "formatearFecha"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
        transferencia: false,
        exportacion: false,
        exportarTancats: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Actiu",
          name: "es_actiu",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Estat",
            options: [
              {
                name: "Actiu",
                value: 1,
              },
              {
                name: "Inactiu",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "es_actiu",
        },
        {
          label: "Seguiment",
          name: "seguiment",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Seguiment",
            options: [
              {
                name: "Amb seguiment",
                value: 1,
              },
              {
                name: "Sense seguiment",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "seguiment",
        },
        {
          label: "Títol",
          name: "titol",
          filter: {
            type: "simple",
            placeholder: "Filtra títol",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Client",
          name: "cliente",
          filter: {
            type: "simple",
            placeholder: "Filtra client",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Responsable",
          name: "trabajador",
          filter: {
            type: "simple",
            placeholder: "Filtra responsable",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Línia de negoci",
          name: "linia_negoci",
          filter: {
            type: "simple",
            placeholder: "Filtra línia",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Data límit",
          name: "data_limit_cell",
          filter: {
            type: "simple",
            placeholder: "Filtra data límit",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Codi pressupost",
          name: "codi_pressupost",
          filter: {
            type: "simple",
            placeholder: "Filtra codi pressupost",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
        {
          label: "",
          name: "cerca_extra",
          visibility: false,
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Tots els projectes",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        proyecto: {
          seguiment: true,
          titol: null,
          id_client: null,
          tipus: null,
          linia_negoci: null,
          responsable: null,
          codi_pressupost: null,
          directori: null,
          horas: {},
          previsio_costos: null,
          marge_comercial: null,
          data_limit: null,
          contacte_nom: null,
          contacte_carrec: null,
          contacte_email: null,
          contacte_telefon: null,
          tags: null,
          notes: null,
        },
        transferencia: {
          id_client: null,
          origen: null,
          destino: null,
        },
      },
      clientes: [],
      clientes_todos: [],
      trabajadores: [],
      tipus: [],
      perfiles: [],
      transferenciaProyectos: [],
      lineas: [],
    };
  },
  computed: {
    transferenciaOrigen() {
      return this.getRowId(this.nuevos.transferencia.origen, this.transferenciaProyectos);
    },
    transferenciaDestino() {
      return this.getRowId(this.nuevos.transferencia.destino, this.transferenciaProyectos);
    },
    minFecha() {
      return new Date().toISOString().split("T")[0];
    },
  },
  methods: {
    getData: function () {
      this.$http.get("api/projectes").then((response) => {
        this.rows = response.data.map(row => ({
          ...row,
          data_limit_format: this.formatearFecha(row.data_limit),
          data_limit_cell: `${row.data_limit} ${this.formatearFecha(row.data_limit)}`,
          cerca_extra: `${row.notes ?? ""} ${row.tags ?? ""}`,
        }));

        this.$http.get("api/hores_previstes").then((response) => {
          this.rows.forEach((element) => {
            element.horas = {};
          });

          response.data.forEach((element) => {
            let row = this.getRowId(element.id_projecte, this.rows);

            if (!row) return;

            row.horas[element.perfil] = element.cantidad;
          });

          this.rowsBuffer = structuredClone(this.rows);
        });
      });

      this.$http.get("api/projectes?valores=tipus").then((response) => {
        this.tipus = response.data;
      });
      this.$http.get("api/clients?order=titol").then((response) => {
        this.clientes_todos = response.data;
      });
      this.$http.get("api/hores_previstes?valores=perfil").then((response) => {
        this.perfiles = response.data;
      });
      this.$http.get("api/treballadors?activos&order=nom").then((response) => (this.trabajadores = response.data));
      this.$http.get("api/projectes?valores=linia_negoci").then(response => this.lineas = response.data);
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    getRowHoras: function (id, rows) {
      let row = this.getRowId(id, rows);

      return row.horas ?? {};
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/projectes", this.nuevos.proyecto)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(() => {
            if (response.status == 201) {
              this.rows.push({
                ...response.data,
                data_limit_format: this.formatearFecha(response.data.data_limit),
                data_limit_cell: `${response.data.data_limit} ${this.formatearFecha(response.data.data_limit)}`,
                cerca_extra: `${response.data.notes ?? ""} ${response.data.tags ?? ""}`,
              });

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Projecte afegit correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/projectes/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(() => {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();
              this.getRowId(id, this.rowsBuffer).cliente = response.data.cliente;
              this.getRowId(id, this.rowsBuffer).trabajador = response.data.trabajador;
              this.getRowId(id, this.rowsBuffer).data_limit_format = this.formatearFecha(response.data.data_limit);
              this.getRowId(id, this.rowsBuffer).data_limit_cell = `${response.data.data_limit} ${this.formatearFecha(response.data.data_limit)}`;
              this.getRowId(id, this.rowsBuffer).cerca_extra = `${response.data.notes ?? ""} ${response.data.tags ?? ""}`;

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Projecte editat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/projectes/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Projecte eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    transferir: function () {
      this.loading.transferencia = true;

      this.$http
        .delete(`api/projectes/${this.nuevos.transferencia.origen}?${new URLSearchParams({ destino: this.nuevos.transferencia.destino })}`)
        .then((response) => {
          this.$nextTick(function () {
            this.$refs[`modalTransferencia`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == this.nuevos.transferencia.origen);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Transferència realitzada correctament.` });
            }
          });
        })
        .finally(() => (this.loading.transferencia = false));
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    intercambiar: function () {
      const origen = this.nuevos.transferencia.origen;
      const destino = this.nuevos.transferencia.destino;

      this.$set(this.nuevos.transferencia, "origen", destino);
      this.$set(this.nuevos.transferencia, "destino", origen);
    },
    cerrarTransferencia: function () {
      this.nuevos.transferencia.id_client = null;

      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    cerrarCreacion: function () {
      this.nuevos.proyecto.seguiment = true;
      this.nuevos.proyecto.titol = null;
      this.nuevos.proyecto.id_client = null;
      this.nuevos.proyecto.tipus = null;
      this.nuevos.proyecto.linia_negoci = null;
      this.nuevos.proyecto.responsable = null;
      this.nuevos.proyecto.codi_pressupost = null;
      this.nuevos.proyecto.directori = null;
      this.nuevos.proyecto.horas = {};
      this.nuevos.proyecto.previsio_costos = null;
      this.nuevos.proyecto.marge_comercial = null;
      this.nuevos.proyecto.data_limit = null;
      this.nuevos.proyecto.contacte_nom = null;
      this.nuevos.proyecto.contacte_carrec = null;
      this.nuevos.proyecto.contacte_email = null;
      this.nuevos.proyecto.contacte_telefon = null;
      this.nuevos.proyecto.notes = null;
      this.nuevos.proyecto.tags = null;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    async getExportData() {
      const filas = this.$refs.tabla.temp_filtered_results;

      if (!filas.length) return null;

      var perfilesHoras = [];

      this.perfiles.forEach(perfil => {
        perfilesHoras[perfil] = filas.map(proyecto => this.rows.find(a => a.id == proyecto.id).horas?.[perfil]);
      });

      const responseDedicaciones = await this.$http.get(`api/dedicacions?proyectos_perfil`);
      const responseConsumos = await this.$http.get(`api/projectes?consumos`);

      const consumos = filas.map(fila => {
        const consumo = responseConsumos.data.find(consumo => consumo.id == fila.id)?.consumo;

        if (!consumo) return null;

        return this.formatearDecimales(consumo, 0);
      });

      var filasCompletas = filas.map((fila, i) => ({
        'id client': fila.id_client,
        'client': fila.cliente,
        'id projecte': fila.id,
        'projecte': fila.titol,
        'data límit': fila.data_limit_format,
        'marge comercial': fila.marge_comercial,
        'previsio costos': fila.previsio_costos,
        'responsable': fila.trabajador,
        '% recursos consumits': consumos[i],
      }));

      this.perfiles.forEach(perfil => {
        filasCompletas = filasCompletas.map((fila, i) => ({
          ...fila,
          ...{
            [`previsió ${perfil.toLowerCase()}`]: perfilesHoras[perfil][i],
          }
        })
        );
      });

      [...this.perfiles, "INDEFINIT"].forEach(perfil => {
        filasCompletas = filasCompletas.map((fila, i) => ({
          ...fila,
          ...{
            [`dedicació ${perfil.toLowerCase()}`]: responseDedicaciones.data?.find(dedicacion => dedicacion.id_projecte == fila["id projecte"] && dedicacion.perfil == perfil)?.total,
          }
        })
        );
      });

      filasCompletas = filas.map((fila, i) => ({
        ...filasCompletas[i],
        ...{
          'actiu': fila.es_actiu,
          'seguiment': fila.seguiment,
          'tipus': fila.tipus,
          'codi pressupost': fila.codi_pressupost,
          'directori': fila.directori,
          'id responsable': fila.responsable,
          'contacte nom': fila.contacte_nom,
          'contacte càrrec': fila.contacte_carrec,
          'contacte email': fila.contacte_email,
          'contacte telèfon': fila.contacte_telefon,
        }
      }));

      filasCompletas.unshift(Object.keys(filasCompletas[0]));

      return filasCompletas;
    },
    getExportDataTancats(filas) {
      if (!filas.length) return null;

      var filasCompletas = filas.map((fila) => ({
        'id projecte': fila.id,
        'projecte': fila.titol,
        'client': fila.cliente,
        'data tancament': fila.data_tancament ? this.formatearFecha(fila.data_tancament) : '',
        'codi pressupost': fila.codi_pressupost,
      }));

      filasCompletas.unshift(Object.keys(filasCompletas[0]));

      return filasCompletas;
    },
    async exportarTablaPrevio() {
      if (this.loading.exportacion) return;

      this.loading.exportacion = true;

      const data = await this.getExportData();

      if (!data) {
        this.loading.exportacion = false;
        return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap projecte per exportar." });
      }

      this.exportarDatos(this.$route.name, data);

      this.loading.exportacion = false;
    },
    async exportarBolcatPrevio() {
      if (this.loading.exportacion) return;

      this.loading.exportacion = true;

      const data = await this.getExportData();

      if (!data) {
        this.loading.exportacion = false;
        return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap projecte per exportar." });
      }

      this.mostrarBolcat(this.$route.name, data);

      this.loading.exportacion = false;
    },
    async exportarTancatsDarrerTrimestre() {
      if (this.loading.exportarTancats) return;

      this.loading.exportarTancats = true;

      const hoy = new Date();
      const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
      const anio = hoy.getFullYear();
      const mes = hoy.getMonth();
      let primerDiaDarrerTrimestre;

      if (mes >= 0 && mes <= 2) {
        primerDiaDarrerTrimestre = new Date(anio - 1, 9, 1);
      } else if (mes >= 3 && mes <= 5) {
        primerDiaDarrerTrimestre = new Date(anio, 0, 1);
      } else if (mes >= 6 && mes <= 8) {
        primerDiaDarrerTrimestre = new Date(anio, 3, 1);
      } else {
        primerDiaDarrerTrimestre = new Date(anio, 6, 1);
      }

      const fechaInicioStr = `${primerDiaDarrerTrimestre.getFullYear()}-${String(primerDiaDarrerTrimestre.getMonth() + 1).padStart(2, '0')}-${String(primerDiaDarrerTrimestre.getDate()).padStart(2, '0')}`;

      const filasFiltradas = this.rows.filter(fila => {
        if (!fila.data_tancament) return false;
        return fila.data_tancament >= fechaInicioStr && fila.data_tancament <= hoyStr;
      });

      const data = this.getExportDataTancats(filasFiltradas);

      if (!data) {
        this.loading.exportarTancats = false;
        return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap projecte tancat en aquest període per exportar." });
      }

      this.mostrarBolcat("Projectes tancats darrer trimestre", data);

      this.loading.exportarTancats = false;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    "loading.exportacion"(value) {
      document.querySelector(".exportar-bolcat").disabled = value;

      document.querySelector(".exportar-bolcat .spinner-border").classList.toggle('d-none');
      document.querySelector(".exportar-bolcat i").classList.toggle('d-none');
    },
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
    "nuevos.transferencia.id_client": function (value) {
      if (value) {
        this.$http.get(`api/projectes?${new URLSearchParams({ cliente: value, order: "titol" })}`).then((response) => {
          this.transferenciaProyectos = response.data;
        });
      } else {
        this.nuevos.transferencia.origen = null;
        this.nuevos.transferencia.destino = null;
        this.transferenciaProyectos = [];
      }
    },
    clientes_todos: function (value) {
      this.clientes = value.filter((a) => a.es_actiu == 1);
    },
  },
};
</script>